var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNaverblog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 25,
    viewBox: "0 0 38 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AAA",
    fillRule: "nonzero",
    d: "M6.144 9.538c3.977.37 3.481 4.539 3.48 4.539-.019 3.567-3.707 3.67-3.707 3.67-1.427 0-2.232-.946-2.232-.946v.644H1V6.366c.165.027 2.685-.006 2.685-.006v4.237c.633-1.078 2.459-1.059 2.459-1.059zm-.826 5.744a1.545 1.545 0 1 0-1.547-1.545c0 .854.692 1.545 1.547 1.545zM10.457 6c4.199.17 3.896 3.878 3.897 3.878v7.585h-2.629v-7.51c0-1.022-1.268-1.305-1.268-1.305V6zm10.129 3.637c2.435 0 4.408 1.816 4.408 4.058 0 2.241-1.972 4.057-4.408 4.057-2.433 0-4.406-1.817-4.406-4.057 0-2.242 1.972-4.058 4.406-4.058zm0 5.721a1.665 1.665 0 1 0 .002-3.33 1.665 1.665 0 0 0-.002 3.33zm11.738-4.799l-.001-.812h2.666v8.006s.039 3.854-3.877 3.854h-1.191V19.11h.719s1.645.151 1.625-2.384c0 0-.32 1.026-2.627 1.026 0 0-3.273-.236-3.273-3.428v-1.211s.076-3.309 3.67-3.574c0 0 1.418-.153 2.289 1.02zm-1.516 4.762a1.628 1.628 0 1 0 .003-3.255 1.628 1.628 0 0 0-.003 3.255z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaverblog);
export default __webpack_public_path__ + "static/media/naverblog.28f66ddcddcf4e99ed518fe1b0645cc7.svg";
export { ForwardRef as ReactComponent };